import { FunctionComponent } from "enzyme";
import { IconProps } from "./constants";

const IconSearch: FunctionComponent<IconProps> = ({ width = "22", height = "21", className = "", name = "search" }) => {
  return (
    <svg
      data-name={name}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2285 19L15.8785 14.8917M18.2286 9.55552C18.2286 13.7283 14.6468 17.111 10.2285 17.111C5.81025 17.111 2.22852 13.7283 2.22852 9.55552C2.22852 5.38272 5.81025 2 10.2285 2C14.6468 2 18.2286 5.38272 18.2286 9.55552Z"
        stroke="#2E2D29"
        strokeOpacity="0.9"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconSearch;
